import styled, { keyframes } from "styled-components";
const image2 = "../../../assets/images/blog3.png";

const move = keyframes`
    0% {
        transform: translateY(0px);
    }
    50%{
        transform: translateY(50px);
    }
    100% {
        transform: translateY(0px);
    }
`;

export const Title = styled.h1`
  text-align: center;
  padding: 0.5em 0;
  color: rgb(259, 91, 65);
  border-bottom: 1px solid #ddd;
`;

export const Plans = styled.div`
  text-align: center;
  h3{
    font-size: 1.2em;
  }
`;

export const Amount = styled.div`
  display: flex;
  padding-bottom: 2em;
  justify-content: center;

  h1 {
    margin: 0;
    font-size: 4em;
  }
  span {
    align-self: flex-end;
  }
`;

export const Wrapper = styled.div``;
export const Container = styled.div`
  flex-wrap: wrap;
  background: url(${image2});
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: 200%;
  background-position: center;

  @media (min-width: 1100px) {
  }
  @media (min-width: 789px) {
    background-size: 100%;
  }
`;
export const Row = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  padding: 2em;
  flex-wrap: wrap;
  row-gap: 4em;
  padding-bottom: 3em;
`;

export const Col = styled.div`
  min-width: 20em;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: #fff;
  padding: 0 3em;

  h1 {
    font-size: 3.5em;
    text-align: center;
  }
  p {
    font-size: 1.2em;
  }
`;
export const Image = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  padding: 3em;

  img {
    display: block;
    width: 100%;
    animation: ${move} 3s ease infinite;
  }

  @media (min-width: 789px) {
    width: 50%;
  }
`;
